import { render, staticRenderFns } from "./updateLog.vue?vue&type=template&id=6807453d&scoped=true"
import script from "./updateLog.vue?vue&type=script&lang=js"
export * from "./updateLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807453d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6807453d')) {
      api.createRecord('6807453d', component.options)
    } else {
      api.reload('6807453d', component.options)
    }
    module.hot.accept("./updateLog.vue?vue&type=template&id=6807453d&scoped=true", function () {
      api.rerender('6807453d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Produce/rmcProAuditorList/updateLog.vue"
export default component.exports